import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import Permission from "Components/Common/Permission";
import UpdateMDA from "../UpdateMDA";
import DeleteModal from "Components/Common/DeleteModal";
import { deleteMda, getMdaAgencies } from "common/services/mda.service";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import * as moment from "moment";
import Skeleton from "react-loading-skeleton";

const RowSkeleton = () => {
  return (
    <Row className="align-items-center">
      <div className="col-md-auto">
        <div className="avatar-md mb-md-0 mb-4">
          <Skeleton width={"100%"} height={"100%"} />
        </div>
      </div>
      <div className="col-md">
        <h4 className="fw-semibold">
          <Skeleton width={150} height={24} />
        </h4>
        <div className="hstack gap-3 flex-wrap">
          <div className="text-muted">
            <Skeleton width={100} height={16} />
          </div>
          <div className="vr"></div>
          <div className="text-muted">
            <Skeleton width={120} height={16} />
          </div>
          <div className="vr"></div>
          <div className="text-muted">
            <Skeleton width={140} height={16} />
          </div>
        </div>
      </div>
    </Row>
  );
};

const Header = ({
  mda,
  fetchData,
  loading,
}: {
  mda: any;
  fetchData: () => {};
  loading: Boolean;
}) => {
  const navigate = useNavigate();

  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const showUpdateModalForm = () => {
    setIsUpdateModalOpen(true);
  };

  const [agencies, setAgencies] = useState<any>([]);

  useEffect(() => {
    const getAgencies = async () => {
      try {
        const response = await getMdaAgencies(mda?.id);
        setAgencies(response.data);
      } catch (e: any) {
        console.warn(e);
      }
    };
    getAgencies();
  }, [mda?.id]);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const handleDelete = async () => {
    try {
      setDeleting(true);
      await deleteMda(mda?.id);

      setDeleting(false);
      setDeleteModal(false);
      navigate("/mdas");
      toast.success("MDA deleted successfully");
    } catch (e: any) {
      toast.error("Error while deleting MDA");
    } finally {
      setDeleting(false);
    }
  };

  return (
    <React.Fragment>
      <Col lg={12}>
        <Card className=" rounded">
          <div className="bg-warning-subtle">
            <CardBody className=" ">
              <Row>
                <div className="col-md">
                  {loading && <RowSkeleton />}
                  {!loading && (
                    <Row className="align-items-center">
                      <div className="col-md-auto">
                        <div className="avatar-md mb-md-0 mb-4">
                          {/* <div className="avatar-title bg-white rounded-circle"> */}
                          <div className="avatar-md img-thumbnail rounded">
                            <div className="avatar-title bg-primary-subtle rounded fs-24 ">
                              <i className="ri-bank-line text-primary"></i>
                            </div>
                            {/* </div> */}
                          </div>
                        </div>
                      </div>
                      <div className="col-md">
                        <h4 className="fw-semibold" id="ticket-title">
                          {mda?.name
                            ? `${mda?.name}${
                                mda?.acronym ? ` (${mda?.acronym})` : ""
                              }`
                            : "N/A"}
                        </h4>
                        <div className="hstack gap-3 flex-wrap">
                          <div className="text-muted">
                            <i className="ri-map-pin-line align-bottom me-1"></i>{" "}
                            <span id="ticket-client">
                              {mda?.region?.name || "N/A"}
                            </span>
                          </div>
                          <div className="vr"></div>

                          <div className="text-muted">
                            Created :{" "}
                            <span className="fw-medium">
                              {moment(new Date(mda?.createdAt)).format(
                                "DD MMM, Y"
                              )}
                            </span>
                          </div>
                          <div className="vr"></div>
                          <div className="text-muted">
                            Last Updated :{" "}
                            <span className="fw-medium">
                              {moment(new Date(mda?.updatedAt)).format(
                                "DD MMM, Y"
                              )}
                            </span>
                          </div>

                          {/* <div
                            className="badge rounded-pill bg-danger fs-12"
                            id="ticket-priority"
                          >
                            High
                          </div> */}
                        </div>
                      </div>
                    </Row>
                  )}
                </div>
                <div className="col-md-auto mt-md-0 mt-4">
                  <div className="hstack gap-1 flex-wrap">
                    <UncontrolledDropdown className="float-end">
                      <DropdownToggle
                        tag="a"
                        className="btn py-0 fs-13 material-shadow-none align-middle  text-primary"
                        role="button"
                      >
                        Actions
                        <i className=" ri-arrow-down-s-fill fs-16 ms-1"></i>
                      </DropdownToggle>
                      <DropdownMenu className="dropdown-menu-end">
                        <Permission action="update" resource="individual">
                          <DropdownItem
                            href="#"
                            className="edit-item-btn"
                            onClick={(e: any) => {
                              e.preventDefault();
                              showUpdateModalForm();
                            }}
                          >
                            <i className="ri-pencil-fill align-bottom me-2 text-muted"></i>{" "}
                            Edit
                          </DropdownItem>
                        </Permission>
                        <Permission action="delete" resource="individual">
                          <DropdownItem
                            href="#"
                            className="remove-item-btn"
                            onClick={(e: any) => {
                              e.preventDefault();
                              setDeleteModal(true);
                            }}
                          >
                            <i className="ri-delete-bin-fill align-bottom me-2 text-muted"></i>{" "}
                            Delete
                          </DropdownItem>
                        </Permission>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>
              </Row>
              {agencies.length > 0 && (
                <Row className="mt-3">
                  <div className="col-md">
                    <div className="hstack gap-3 flex-wrap">
                      {agencies.map((agency: any) => {
                        if (agency?.hasActiveContract) {
                          return (
                            <div className="bg-white rounded-pill px-0 py-0 ">
                              <div
                                className="bg-primary text-white px-3 py-1 rounded-pill"
                                key={agency.id}
                              >
                                {agency.name}
                              </div>
                            </div>
                          );
                        }
                        return (
                          <div className="bg-white rounded-pill px-0 py-0 ">
                            <div
                              className="bg-primary-subtle text-primary px-3 py-1 rounded-pill"
                              key={agency.id}
                            >
                              {agency.name}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Row>
              )}
              <UpdateMDA
                toggle={() => setIsUpdateModalOpen((state) => !state)}
                isModalOpen={isUpdateModalOpen}
                selectedRecord={mda}
                fetchData={fetchData}
              />
              <DeleteModal
                show={deleteModal}
                onDeleteClick={() => handleDelete()}
                onCloseClick={() => setDeleteModal(false)}
                loading={deleting}
              />
            </CardBody>
          </div>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default Header;
